import { PlanType } from '../../../store/funnelV3Store';
import { EXIT_INTENT_PRICES } from '../paywall/exitIntentPrices';

/** Mirrors FunnelV3Flow PLAN_BASE_PRICES_CENTS — keep in sync. */
export const JOIN_PLAN_BASE_PRICES_CENTS: Record<PlanType, number> = {
    '1_week_trial': 795,
    '4_week': 2195,
    '12_week': 3895,
};

interface ExpressCheckoutInput {
    selectedPlan: PlanType;
    exitDiscountActive: boolean;
    promoDiscountPercent: number;
    referralDiscountPercent: number;
}

/** Mirrors buildPaymentElementsOptions charge amount logic in FunnelV3Flow. */
export function resolveExpressCheckoutAmountCents(input: ExpressCheckoutInput): number {
    const basePriceCents = JOIN_PLAN_BASE_PRICES_CENTS[input.selectedPlan];
    let chargeAmount = basePriceCents;

    if (input.exitDiscountActive) {
        const exitPrice = EXIT_INTENT_PRICES[input.selectedPlan];
        if (exitPrice !== undefined) {
            chargeAmount = Math.round(exitPrice * 100);
        }
    } else if (input.promoDiscountPercent > 0) {
        chargeAmount = Math.round(basePriceCents * (1 - input.promoDiscountPercent / 100));
    } else if (input.referralDiscountPercent > 0) {
        chargeAmount = Math.round(
            basePriceCents * (1 - input.referralDiscountPercent / 100)
        );
    }

    return chargeAmount;
}

interface BackendPlanPriceInput {
    price: number;
    firstChargePrice?: number;
    intervalCount: number;
}

/** Mirrors PaywallStep mapPlan pricing derivation. */
export function mapJoinPlanCardPrices(plan: BackendPlanPriceInput): {
    displayPrice: number;
    originalPrice: number;
} {
    const basePrice = (plan.firstChargePrice || plan.price) / 100;
    const originalPrice = plan.firstChargePrice ? plan.price / 100 : basePrice * 2;
    return { displayPrice: basePrice, originalPrice };
}
